export default {
  'buttons.save': 'Değişiklikleri Kaydet',
  'buttons.cancel': 'İptal',
  'buttons.reset': 'Sıfırla',
  'buttons.nextStep': 'Sonraki Adım',
  'buttons.previousStep': 'Önceki Adım',
  'buttons.delete': 'Sil',
};
